import { render } from "./PartnerPage.vue?vue&type=template&id=3308d2bc&scoped=true"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"

import "./PartnerPage.vue?vue&type=style&index=0&id=3308d2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3308d2bc"]])

export default __exports__